export enum DayOfWeek {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}

export function getWeekName(weekId: DayOfWeek) {
  switch (weekId) {
    case DayOfWeek.SUNDAY: return 'Sunday';
    case DayOfWeek.MONDAY: return 'Monday';
    case DayOfWeek.TUESDAY: return 'Tuesday';
    case DayOfWeek.WEDNESDAY: return 'Wednesday';
    case DayOfWeek.THURSDAY: return 'Thursday';
    case DayOfWeek.FRIDAY: return 'Friday';
    case DayOfWeek.SATURDAY: return 'Saturday';
  }
}

export function getWeekId(weekName?: string) {
  switch (weekName?.toLowerCase()) {
    case 'sunday': return 0;
    case 'monday': return 1;
    case 'tuesday': return 2;
    case 'wednesday': return 3;
    case 'thursday': return 4;
    case 'friday': return 5;
    case 'saturday': return 6;
    default: return;
  }
}